import { render, staticRenderFns } from "./OtherProjects.vue?vue&type=template&id=7de61920&"
import script from "./OtherProjects.vue?vue&type=script&lang=js&"
export * from "./OtherProjects.vue?vue&type=script&lang=js&"
import style0 from "./OtherProjects.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports